<template>
  <div
    class="mega-nav"
    :class="{
      'mega-nav--small': columnCount <= 2,
      'mega-nav--wide': wide
    }"
  >
    <div class="mega-nav__container">
      <ul
        class="mega-nav__navigation"
        :style="{
          '--columns': columnCount
        }"
      >
        <li
          v-for="tier2 in items"
          :key="tier2.handle"
          class="mega-nav__list"
          :class="{
            'mega-nav__list--empty': !itemHasChildren(tier2)
          }"
        >
          <a
            class="mega-nav__link text-body-sbold"
            :href="tier2.url"
            @click="megaNavLinkDataLayer(`${tierTitle} > ${tier2.title}`, 2)"
            v-text="tier2.title"
          />

          <ul v-if="itemHasChildren(tier2)">
            <li
              v-for="tier3 in tier2.items"
              :key="tier3.handle"
            >
              <a
                class="mega-nav__link text-body-s"
                :href="tier3.url"
                @click="megaNavLinkDataLayer(`${tierTitle} > ${tier2.title} > ${tier3.title}`, 3)"
                v-text="tier3.title"
              />
            </li>
          </ul>
        </li>
      </ul>

      <div
        v-if="content && content.length"
        class="mega-nav__content"
      >
        <mega-nav-content
          v-for="block in content"
          :key="block.title"
          :tier-title="tierTitle"
          :title="block.title"
          :subtitle="block.subtitle"
          :button="block.button"
          :url="block.url"
          :image="block.image"
          :image-arabic="block.image_arabic"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Mega nav (mega-nav)
 * -----------------------------------------------------------------------------
 * Statically rendered list of links with supporting content.
 *
 */
import MegaNavContent from '~global/mega-nav/mega-nav-content'
import { getColumnCount } from '~global/site-header/site-header'

export default {
  name: 'MegaNav',

  components: {
    MegaNavContent,
  },

  props: {

    /**
     * The parent tier's title.
     */
    tierTitle: {
      type: String,
      default: '',
    },

    /**
     * Navigation items, with a handle, title and url.
     */
    items: {
      type: Array,
      default: () => [],
    },

    /**
     * A list of content blocks, with image, title etc.
     */
    content: {
      type: Array,
      default: () => [],
    },

    /**
     * Enables container styling to account for wider layouts.
     */
    wide: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      global: true,
    }
  },

  computed: {

    /**
     * Returns the number of columns to display.
     * @returns {Number}
     */
    columnCount() {
      return getColumnCount(this.items)
    },
  },

  methods: {

    /**
     * Returns if the given item has children items.
     * @param {Object} item - The item to test.
     * @returns {Boolean}
     */
    itemHasChildren(item) {
      return item.items && item.items.length
    },

    /**
     * Send the mega nav link click event info to the data layer.
     * @param {String} label - clicked link title.
     * @param {Number} tier - clicked link tier.
     */
     megaNavLinkDataLayer(label, tier) {
      cnvs.EventBus.emit('Datalayer:megaNavLink', ({ label, tier }))
    },

  },
}
</script>
